






























































































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import 'reflect-metadata';
import { inject } from 'vue-typescript-inject';

@Component({
  props: ['items'],
})
export default class ListVoices extends Vue {

  /**
   * createdフック
   */
  public created(): void {
    (window as any).$ = require('jquery');
  }

  /**
   * 詳細ページに移動
   */
  public popDetail(event: any, path: string, index: any): void {
    if ((this as any).mq('md-')) {
      this.$router.push({
        name: path,
      });
      return;
    }

    const position = [
      {
        top: -15,
        right: -74,
      },
      {
        top: -5,
        right: -89,
      },
      {
        top: -5,
        right: -89,
      },
      {
        top: -2,
        right: -97,
      },
      {
        top: -5,
        right: -69,
      },
      {
        top: -5,
        right: -89,
      },
      {
        top: -5,
        right: -89,
      },
    ];

    const image = (event.currentTarget as any).querySelector('.fn-image');
    const copy: any = image.cloneNode(true);
    const rect: any = image.getBoundingClientRect();
    copy.setAttribute('id', 'pop-image');
    copy.classList.add('pop-image');
    copy.style.top = window.scrollY + rect.top + 'px';
    copy.style.left = window.scrollX + rect.left + 'px';
    document.body.appendChild(copy);
    document.body.style.overflow = 'hidden';
    image.style.opacity = '0';
    document.getElementById('professionals')!.classList.add('is-hide');
    copy.classList.add('is-animation');

    setTimeout((): void => {
      const width: number = document.getElementById('intro-inner')!.clientWidth;
      $(copy).animate({
        top: 50 + position[index].top + 'px',
        left: ((window.innerWidth - width) / 2) + (width - copy.clientWidth) - position[index].right + 'px',
      }, 200, (): void => {
        copy.classList.add('is-fixed');
        this.$router.push({
          name: path,
        }, (): void => {
          this.$store.commit('setFixed', true);
        });
      });
      $('html, body').animate({
        scrollTop: 0,
      }, 200);
    }, 100);
  }

}
